export const MON_ABBR = ['STY', 'LUT', 'MAR', 'KWI', 'MAJ', 'CZE', 'LIP', 'SIE', 'WRZ', 'PAŹ', 'LIS', 'GRU'];
export const MON_NAME = ['styczeń', 'luty', 'marzec', 'kwiecień', 'maj', 'czerwiec', 'lipiec', 'sierpień', 'wrzesień', 'październik', 'listopad', 'grudzień'];
export const MON_GEN = ['stycznia', 'lutego', 'marca', 'kwietnia', 'maja', 'czerwca', 'lipca', 'sierpnia', 'września', 'października', 'listopada', 'grudnia'];
export const DOW = ['niedziela', 'poniedziałek', 'wtorek', 'środa', 'czwartek', 'piątek', 'sobota'];
export const DOW_S = ['nd', 'pn', 'wt', 'śr', 'czw', 'pt', 'sob'];

export const pad = (n: number) => String(n).padStart(2, '0');
/** Miesiąc 1–12 */
export const D = (y: number, m: number, d: number) => new Date(y, m - 1, d);
export const ymd = (d: Date) => `${d.getFullYear()}-${pad(d.getMonth() + 1)}-${pad(d.getDate())}`;
export const isYMD = (s: unknown): s is string => typeof s === 'string' && /^\d{4}-\d{2}-\d{2}$/.test(s);
export const isYM = (s: unknown): s is string => typeof s === 'string' && /^\d{4}-\d{2}$/.test(s);
export function parseD(s: string | undefined | null): Date | null {
  if (!isYMD(s)) return null;
  const [y, m, d] = s.split('-').map(Number);
  return new Date(y, m - 1, d);
}
export const addDays = (d: Date, n: number) => new Date(d.getFullYear(), d.getMonth(), d.getDate() + n);
export const ymOf = (s: string | undefined | null) => (s ? String(s).slice(0, 7) : '');
export function ymAdd(ym: string, n: number): string {
  let [y, m] = ym.split('-').map(Number);
  m += n;
  while (m > 12) { m -= 12; y++; }
  while (m < 1) { m += 12; y--; }
  return `${y}-${pad(m)}`;
}
export const dim = (y: number, m: number) => new Date(y, m, 0).getDate();
export function fmtD(s: string | Date | null | undefined): string {
  const d = typeof s === 'string' ? parseD(s) : s;
  return d ? `${pad(d.getDate())}.${pad(d.getMonth() + 1)}.${d.getFullYear()}` : '—';
}
export const fmtYM = (ym: string | undefined | null) => (ym ? `${ym.slice(5)}.${ym.slice(0, 4)}` : '—');
export function daysBetween(a: Date, b: Date): number {
  return Math.round((Date.UTC(b.getFullYear(), b.getMonth(), b.getDate()) - Date.UTC(a.getFullYear(), a.getMonth(), a.getDate())) / 864e5);
}
export const today0 = () => {
  const n = new Date();
  return new Date(n.getFullYear(), n.getMonth(), n.getDate());
};
export const nowYM = () => ymd(today0()).slice(0, 7);

/** Wielkanoc (algorytm Meeusa/Jonesa/Butchera) */
export function easter(y: number): Date {
  const a = y % 19, b = Math.floor(y / 100), c = y % 100, d = Math.floor(b / 4), e = b % 4, f = Math.floor((b + 8) / 25),
    g = Math.floor((b - f + 1) / 3), h = (19 * a + b - d - g + 15) % 30, i = Math.floor(c / 4), k = c % 4,
    l = (32 + 2 * e + 2 * i - h - k) % 7, m = Math.floor((a + 11 * h + 22 * l) / 451),
    mo = Math.floor((h + l - 7 * m + 114) / 31), da = ((h + l - 7 * m + 114) % 31) + 1;
  return new Date(y, mo - 1, da);
}

const HOL: Record<number, Set<string>> = {};
/** Dni ustawowo wolne w Polsce (Wigilia od 2025 r.) */
export function holidays(y: number): Set<string> {
  if (HOL[y]) return HOL[y];
  const e = easter(y);
  const s = new Set([
    `${y}-01-01`, `${y}-01-06`, ymd(e), ymd(addDays(e, 1)), `${y}-05-01`, `${y}-05-03`,
    ymd(addDays(e, 49)), ymd(addDays(e, 60)), `${y}-08-15`, `${y}-11-01`, `${y}-11-11`, `${y}-12-25`, `${y}-12-26`,
  ]);
  if (y >= 2025) s.add(`${y}-12-24`);
  return (HOL[y] = s);
}
export const isBiz = (d: Date) => {
  const w = d.getDay();
  return w !== 0 && w !== 6 && !holidays(d.getFullYear()).has(ymd(d));
};
export function nextBiz(d: Date): Date {
  while (!isBiz(d)) d = addDays(d, 1);
  return d;
}
export function prevBiz(d: Date): Date {
  while (!isBiz(d)) d = addDays(d, -1);
  return d;
}
export function whyShift(d: Date): string {
  const w = d.getDay();
  return w === 6 ? 'sobota' : w === 0 ? 'niedziela' : 'święto';
}
